import type { AuthProvider } from 'ra-core';

const API_URL = '/api';

export const authProvider: AuthProvider = {
    async login({ username, password }: { username: string; password: string }) {
        const response = await fetch(`${API_URL}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ email: username, password }),
        });

        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new Error(body.message || 'Identifiants incorrects');
        }

        const { token, user } = await response.json();
        localStorage.setItem('auth_token', token);
        localStorage.setItem('auth_user', JSON.stringify(user));
    },

    async logout() {
        const token = localStorage.getItem('auth_token');
        if (token) {
            await fetch(`${API_URL}/auth/logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }).catch(() => {});
        }
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
    },

    async checkAuth() {
        const token = localStorage.getItem('auth_token');
        if (!token) throw new Error('No token');
    },

    async checkError(error: { status?: number }) {
        if (error.status === 401 || error.status === 403) {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('auth_user');
            throw new Error('Unauthorized');
        }
    },

    async getIdentity() {
        const raw = localStorage.getItem('auth_user');
        if (!raw) throw new Error('No user');
        const user = JSON.parse(raw);
        return {
            id: user.id,
            fullName: user.name,
            avatar: undefined,
        };
    },

    async getPermissions() {
        return undefined;
    },
};
